import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-raffle-counters__left" }
const _hoisted_2 = { class: "bonusomat-raffle-counters__right" }

import { computed } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatRaffleCountersGroup from "./bonusomat-raffle-counters-group.vue";
import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";
import { bonImgUrl } from "../../utils/image-src";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-raffle-counters-section',
  props: {
    hasRaffleDataLoadingFailed: { type: Boolean },
    showDefaultCounters: { type: Boolean },
    totalWin: {},
    raffleRemainingSeconds: {},
    showAllwynCounters: { type: Boolean },
    allwynName: {},
    allwynRemainingSeconds: {},
    showTicketsCounters: { type: Boolean },
    raffleTicketsCount: {},
    allwynTicketsCount: {},
    isWidget: { type: Boolean }
  },
  emits: ["openWinTableModal"],
  setup(__props: any, { emit: __emit }) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const { openBonusomatOnboarding } = useBonusomatOnboarding();

const props = __props;

const emit = __emit;

const headlineText = computed(() =>
    props.showDefaultCounters && props.showAllwynCounters ? "Losovačky" : "Losovačka"
);

const openModal = async () => {
    emit("openWinTableModal");
};

const openBonusomatOnboardingClick = () => {
    openBonusomatOnboarding("raffle");
    BonusomatDatalayer.pushMoreInfoClick("Losovačka", bonusomatPlayerData.value.points, remainingSpinsCount.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bonusomat-raffle-counters", { 'bonusomat-raffle-counters--one-group-only': !_ctx.showAllwynCounters || !_ctx.showDefaultCounters }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TypographyHeadline, {
        type: "section",
        theme: "dark",
        class: "bonusomat-raffle__headline"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(headlineText.value) + " ", 1),
          _createVNode(DsButton, {
            type: "text",
            theme: "dark",
            "icon-right": "help",
            onClick: openBonusomatOnboardingClick,
            class: "button-onboarding"
          }),
          (_ctx.showDefaultCounters || _ctx.showAllwynCounters)
            ? (_openBlock(), _createBlock(DsButton, {
                key: 0,
                theme: "dark",
                type: "interaction",
                size: "sm",
                "icon-right": "gift",
                onClick: openModal
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" O co hrajeme? ")
                ])),
                _: 1,
                __: [0]
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(WebpImage, {
        src: _unref(bonImgUrl)('raffle/raffle-mr-red-green', 'png'),
        alt: "Pan Zelený a červený stojící vedle Bonusomatu",
        class: "bonusomat-raffle-counters__image-wrapper bonusomat-raffle-counters__image--mobile",
        "css-class": "bonusomat-raffle-counters__image"
      }, null, 8, ["src"]),
      _createVNode(BonusomatRaffleCountersGroup, {
        hasRaffleDataLoadingFailed: _ctx.hasRaffleDataLoadingFailed,
        showDefaultCounters: _ctx.showDefaultCounters,
        totalWin: _ctx.totalWin,
        raffleRemainingSeconds: _ctx.raffleRemainingSeconds,
        showAllwynCounters: _ctx.showAllwynCounters,
        allwynName: _ctx.allwynName,
        allwynRemainingSeconds: _ctx.allwynRemainingSeconds,
        showTicketsCounters: _ctx.showTicketsCounters,
        raffleTicketsCount: _ctx.raffleTicketsCount,
        allwynTicketsCount: _ctx.allwynTicketsCount,
        isWidget: _ctx.isWidget
      }, null, 8, ["hasRaffleDataLoadingFailed", "showDefaultCounters", "totalWin", "raffleRemainingSeconds", "showAllwynCounters", "allwynName", "allwynRemainingSeconds", "showTicketsCounters", "raffleTicketsCount", "allwynTicketsCount", "isWidget"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WebpImage, {
        src: _unref(bonImgUrl)('raffle/mr-red-raffle', 'png'),
        alt: "Pan červený stojící vedle losovadla",
        class: "bonusomat-raffle-counters__image-wrapper bonusomat-raffle-counters__image--desktop",
        "css-class": "bonusomat-raffle-counters__image"
      }, null, 8, ["src"])
    ])
  ], 2))
}
}

})